export default "__VITE_ASSET__Br51xVvO__"